import React from 'react';
import PropTypes from 'prop-types';
import { withHandlers, withStateHandlers, lifecycle, compose } from 'recompose';
import { connect } from 'react-redux';

import { Button } from '@ontruck/orc';

import { pushWithQuery as push } from 'utils/routing';

import { Loading } from 'components/Loading';

import { getDriverWithUserId } from 'redux/modules/driver-position/http';
import { pagesMap } from 'redux/modules/traffic-common/effects';

const enhance = compose(
  connect(null),
  withStateHandlers(
    () => ({
      name: '',
      loading: false,
      driver_id: 0,
      carrier_id: 0,
    }),
    {
      setData:
        () =>
        ({ name, carrier_id }) => ({
          name,
          carrier_id,
        }),
      toggleLoading:
        ({ loading }) =>
        () => ({
          loading: !loading,
        }),
    }
  ),
  withHandlers({
    openCarrierPage:
      ({ carrier_id }) =>
      () => {
        push(pagesMap.carrier({ carrier_id }));
      },
  }),
  lifecycle({
    async componentDidMount() {
      const { toggleLoading, setData, user_id } = this.props;

      try {
        toggleLoading();

        const driver = await getDriverWithUserId(user_id);
        const { contact_name, carrier_id } = driver;

        setData({
          name: contact_name,
          carrier_id,
        });
      } catch (err) {
      } finally {
        toggleLoading();
      }
    },
  })
);

const DriverNameLoader = ({ loading, name, openCarrierPage }) => {
  if (loading) {
    return <Loading />;
  }
  return <Button nude skin="primary" text={name} label={name} onClick={openCarrierPage} />;
};

DriverNameLoader.propTypes = {
  loading: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  openCarrierPage: PropTypes.func.isRequired,
};

export default enhance(DriverNameLoader);
